import config from '../config';

/** The AMS consent-document vocabulary — same values the consent ledger stores. */
export type PolicyDocumentType = 'terms_of_use' | 'privacy_policy';

/** Current published policy document, as served by the innovate-service proxy. */
export interface PolicyDocument {
  documentType: string;
  version: string;
  /** Full policy text as markdown (H1 title on the first line). */
  content: string;
  effectiveAt: string;
}

/**
 * Fetches the current published policy document via the innovate-service
 * public proxy (GET /api/consent/documents/:type — task 441).
 *
 * Uses plain fetch rather than the shared axios instance in services/api.ts:
 * the policy pages render on the PUBLIC branch of App.tsx (pre-auth,
 * pre-consent), so none of the Authorization/refresh interceptors apply, and
 * pulling the full api module into the public bundle is unnecessary.
 */
export async function fetchCurrentDocument(type: PolicyDocumentType): Promise<PolicyDocument> {
  const response = await fetch(`${config.API_URL}/api/consent/documents/${type}`);

  if (!response.ok) {
    throw new Error(`Policy document fetch failed: ${response.status}`);
  }

  const body = (await response.json()) as { success: boolean; data?: PolicyDocument };
  if (!body.success || !body.data || typeof body.data.content !== 'string') {
    throw new Error('Policy document response had an unexpected shape');
  }

  return body.data;
}
